import { useQuery } from "@tanstack/react-query";
import $api from "~@/api";
import { GetPlayerByUserIdInput, WithToken } from "~@/api/models";
import { useAuth } from "~@/hoc/withAuthenticationRequired";

export const fetchPlayer = async (
  variables: WithToken<GetPlayerByUserIdInput>
) => {
  try {
    const response = await $api.players.getPlayerByUserId({ ...variables });
    if (response.status === 404 || !response.data) {
      return null;
    }
    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 404 || error?.status === 404) {
      return null;
    }
    throw error;
  }
};

type UsePlayerByUserIdQueryOptions = {
  input: GetPlayerByUserIdInput;
  enabled?: boolean;
};

const usePlayerByUserIdQuery = ({
  input,
  enabled,
}: UsePlayerByUserIdQueryOptions) => {
  const { isAuthenticated, token } = useAuth();

  const { data, isLoading, isPending, isError, error } = useQuery({
    queryKey: ["player-by-user-id", input],
    queryFn: () => {
      return fetchPlayer({ ...input, token: token! });
    },
    retry(_failureCount, _error) {
      return false;
    },
    enabled: isAuthenticated && typeof token === "string" && enabled,
  });

  return { data, isLoading, isPending, isError, error };
};

export default usePlayerByUserIdQuery;
